import { InfoUpObj } from "@/commons/interface/project/info-detail";
import { manageAxios } from "@/config/axios";
import { AxiosResponse } from "axios";


export function createInfoUp(infoUpObj: InfoUpObj, type: string, params?: {}): Promise<AxiosResponse<any>> {
    return manageAxios.post(`upload-element-file`, infoUpObj, {
        params: {
            ...params,
            type: type
        }
    })
}

export function findFiles(type: string, params?: {}): Promise<AxiosResponse<any>> {
    return manageAxios.get(`/find-element-files`, {
        params: {
            ...params,
            type: type
        }
    })
}
export function deleteFile(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return manageAxios.delete(`/delete-element-file`, {
        params: {
            ...params,
            id: id
        }
    })
}

export function findRecords(params?: {}): Promise<AxiosResponse<any>> {
    return manageAxios.get(`/find-element-records`, {
        params: {
            ...params,
        }
    })
}